export default __webpack_public_path__ + "images/cf697beaa2a30ea8341ff0f2defe2e86.svg";